import { StyledProgressBar } from '@apps/createWedding/components/ProgressBar/ProgressBar.styled';
import React from 'react';
import { useProgressBarController } from '@apps/createWedding/components/ProgressBar/ProgressBar.controller';

export const ProgressBar = () => {
  const { filled, hidden } = useProgressBarController();

  return <StyledProgressBar value={filled} hidden={hidden} />;
};
